import type { ReactNode } from 'react';
import { ContractIllustration } from '@/components/auth/ContractIllustration';
import { PRODUCT_URLS } from '@podus/utils';

export function AuthLayout({ children }: { children: ReactNode }) {
    return (
        <div className="flex min-h-dvh flex-col bg-background">
            {/* Auth card area */}
            <div className="flex flex-1 justify-end p-0 sm:p-4 sm:pr-0 lg:p-8 lg:pr-0">
                <div className="relative flex min-h-dvh w-full max-w-437.5 overflow-hidden border-border bg-muted sm:my-auto sm:min-h-0 sm:rounded-[23px] sm:rounded-r-none sm:border">
                    {/* Left panel - illustration with grid background */}
                    <div className="relative hidden w-1/2 lg:block">
                        <div
                            className="absolute inset-0"
                            style={{
                                backgroundImage:
                                    'linear-gradient(to right, var(--color-ghost) 1px, transparent 1px), linear-gradient(to bottom, var(--color-ghost) 1px, transparent 1px)',
                                backgroundSize: '132px 132px',
                            }}
                        />
                        <div
                            className="absolute inset-0"
                            style={{
                                background:
                                    'radial-gradient(ellipse at center, transparent 0%, var(--color-muted) 70%)',
                            }}
                        />
                        <div className="relative flex h-full items-center justify-center px-10 py-16 xl:px-16">
                            <div className="w-full max-w-[527px]">
                                <ContractIllustration />
                            </div>
                        </div>
                    </div>

                    {/* Right panel - form */}
                    <div className="flex w-full min-h-0 flex-col justify-center px-5 py-10 sm:min-h-215 sm:px-10 lg:w-1/2 xl:px-16">
                        <div className="mx-auto w-full max-w-120.5 flex-1 flex flex-col justify-center">
                            <div className="mb-6 sm:mb-9.5">
                                <img src="/logo/podus_full_1.svg" alt="Podus AI" className="h-6 sm:h-8" />
                            </div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="flex items-center justify-center gap-4 py-4 text-xs text-text-light sm:text-sm">
                <a
                    href={PRODUCT_URLS.podus}
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-foreground"
                >
                    Home
                </a>
                <span className="text-border">|</span>
                <a
                    href={PRODUCT_URLS.podushelp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-foreground"
                >
                    Help
                </a>
                <span className="text-border">|</span>
                <a
                    href={`${PRODUCT_URLS.podushelp}/privacy`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-foreground"
                >
                    Privacy
                </a>
                <span className="text-border">|</span>
                <a
                    href={`${PRODUCT_URLS.podushelp}/terms`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-foreground"
                >
                    Terms
                </a>
            </footer>
        </div>
    );
}
